module.exports = __webpack_public_path__ + "img/saletitle.e15651e0.png";